import debounce from 'lodash.debounce';
import PerfectScrollbar from 'perfect-scrollbar';
import Swiper from 'swiper/dist/js/swiper'

// TODO: write docs and do refactoring

class Map {
  constructor(config) {
    this.elem = $(config);
    this.dealers = [];
    this.markers = [];
    this.cities = [];
    this.dealerSlider = null;
    this.init();
    this.tabs.on('click', this.tabsHandler.bind(this));
    this.toggleBtn.on('click', this.toggleHandler.bind(this));
  }

  init() {
    this.sidebar = this.elem.find('.js-map-sidebar');
    this.initBlock = this.elem.find('.js-map-init');
    this.tabs = this.elem.find('.js-dealer-tab');
    this.tabsSliderElem = this.elem.find('.js-dealers-tab-slider');
    this.toggleBtn = this.elem.find('.js-toggle-map');
    this.zoom = parseInt(this.initBlock.attr('data-zoom'), 10);
    this.icon = this.initBlock.attr('data-pin-src');
    this.latInit = parseFloat(this.elem.find('.js-dealer-tab.is-all').attr('data-lat'));
    this.lngInit = parseFloat(this.elem.find('.js-dealer-tab.is-all').attr('data-lng'));
    window.onload = () => this.loadMapsAPI();
    window.addEventListener('resize', debounce(this.onResize.bind(this), 500));
  }

  static createScript(url, callback) {
    const script = document.createElement('script');
    if (callback) script.onload = callback;
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
  }

  loadMapsAPI() {
    const mapKey = this.elem.find('.js-map-init').attr('data-map-key');
    Map.createScript(`https://maps.googleapis.com/maps/api/js?key=${mapKey}`, this.initMap.bind(this));
  }

  initMap() {
    const { google } = window;

    const markerIcon = {
      url: this.icon,
      scaledSize: new google.maps.Size(34, 42),
      origin: new google.maps.Point(0, 0),
    };

    this.map = new google.maps.Map(this.initBlock[0], {
      zoom: this.zoom,
    });

    const jsonUrl = this.initBlock.attr('data-json');
    // const jsonUrl = Map.getUrl("data/dealers"); // for local development

    $.getJSON(jsonUrl, (data) => {
      const dataItems = data.dealers;

      // this.tabsCreate(dataItems);
      this.tabsSlider();

      dataItems.forEach((dealer) => {
        const lat = parseFloat(dealer.latitude);
        const lng = parseFloat(dealer.longitude);

        const marker = new google.maps.Marker({
          position: { lat, lng },
          map: this.map,
          icon: markerIcon,
          id: dealer.id
        });

        this.dealers.push(dealer);
        this.markers.push(marker);
        const { id, title, icon, address, website, latitude, longitude, city, pantone } = dealer;
        const pantoneText = dealer.pantone_text;

        const pantoneHTML = pantone ? `
          <div class="dealers-map-address__icon-pantone">
            <img src="${pantone}" alt="${pantoneText}">
            <span>${pantoneText || ''}</span>
          </div>` : '';

        this.sidebar.append(`
          <div class="dealers-map-address" data-lat="${latitude}" data-long="${longitude}" data-id="${id}" data-city="${city}">
            <div class="dealers-map-address__inner">
              <img src="${icon}" alt="${title}" class="dealers-map-address__icon">
              <div class="dealers-map-address__content">
                <div class="dealers-map-address__title">${title}</div>
                <div class="dealers-map-address__address">${address}</div>
                <div class="dealers-map-address__website">${website}</div>
              </div>
            </div>
            ${pantoneHTML}
          </div>
        `)
      });

      this.map.setCenter({ lat: this.latInit, lng: this.lngInit });

      this.ps = new PerfectScrollbar(this.sidebar[0], {
        wheelSpeed: 2,
        wheelPropagation: true,
      });

      const $addressesElems = $('.dealers-map-address');
      $addressesElems.on('click', (e) => {
        const $address = $(e.currentTarget);
        const lat = parseFloat($address.attr('data-lat'));
        const lng = parseFloat($address.attr('data-long'));
        this.map.setZoom(18);
        this.map.setCenter({ lat, lng });
        $('.dealers-map-address').removeClass('is-active');
        $address.addClass('is-active');
        this.toggleHandler();
        this.dealerAbout();
      });

      this.markersClickHandler();
    });
    this.disableLoader();
  }

  tabsCreate(dealers) {
    this.allCities = dealers;
    const cities = {};
    // eslint-disable-next-line no-unused-vars
    const newPlaces = dealers.filter((entry) => {
      if (cities[entry.city]) {
        return false;
      }
      cities[entry.city] = true;
      return true;
    });
    // eslint-disable-next-line no-return-assign,no-sequences,no-unused-vars
    const result = this.allCities.reduce( (acc, o) => (acc[o.city] = (acc[o.city] || 0) + 1, acc), {} );
    this.tabs = this.elem.find('.js-dealer-tab');
  }

  tabsHandler(e) {
    const $tab = $(e.currentTarget);
    const $addresses = $('.dealers-map-address');
    const lat = parseFloat($tab.attr('data-lat'));
    const lng = parseFloat($tab.attr('data-lng'));
    const city = $tab.attr('data-city').toLowerCase();
    const showAllData = $tab.hasClass('is-all');
    const zoom = showAllData ? this.zoom : 11;
    this.tabs.removeClass('is-active');
    $tab.addClass('is-active');
    $addresses.removeClass('is-active');
    const inactiveDealers = this.dealers.filter((dealer) => city !== dealer.city.toLowerCase());

    if (!showAllData) {
      $addresses.show();
      inactiveDealers.forEach((dealer) => {
        $(`.dealers-map-address[data-id="${dealer.id}"]`).hide();
      });
    } else {
      $addresses.show();
    }
    if (this.ps) this.ps.update();

    this.map.setZoom(zoom);
    this.map.setCenter({ lat, lng });
  }

  tabsSlider() {
    const slides = this.tabsSliderElem.find('.swiper-slide');
    const prevEl = this.elem.find('.js-swiper-button-prev');
    const nextEl = this.elem.find('.js-swiper-button-next');
    let slidesWidth = 0;

    slides.each((index, el) => {
      slidesWidth += parseInt($(el).outerWidth(), 10);
    });
    const isOverflowed = slidesWidth > parseInt(this.tabsSliderElem.outerWidth(), 10);

    if (!isOverflowed) {
      this.tabsSliderElem.removeClass('is-overflowed');
    } else {
      this.tabsSliderElem.addClass('is-overflowed');
    }

    this.tabsSliderIns = new Swiper(this.tabsSliderElem, {
      threshold: 10,
      slidesPerView: 'auto',
      navigation: {
        nextEl,
        prevEl,
      },
    });
  }

  toggleHandler() {
    this.elem.toggleClass('is-map-opened');
  }

  markersClickHandler() {
    const { google } = window;
    this.markers.forEach((marker) => {
      google.maps.event.addListener(marker, 'click', () => {
        const hasSelected = $('.dealers-map-address').is('.is-active');
        const $dealer = $(`.dealers-map-address[data-id="${marker.id}"]`);
        const lat = parseFloat($dealer.attr('data-lat'));
        const lng = parseFloat($dealer.attr('data-long'));

        $dealer.addClass('is-active');
        if (hasSelected) {
          const externalMapLink = document.createElement("a");
          externalMapLink.target = '_blank';
          externalMapLink.href = `https://www.google.com/maps?saddr&daddr=${lat},${lng}`;
          externalMapLink.click();
          externalMapLink.remove();
        }
        this.map.setZoom(18);
        this.map.panTo(marker.getPosition());
        this.dealerAbout();
      });
    });
  }

  dealerAbout() {
    const id = parseInt($('.dealers-map-address.is-active').attr('data-id'), 10);
    const $description = $('.js-dealer-text');
    const $imagesWrapper = $('.js-dealer-images-wrapper');
    const $slider = $('.js-dealer-slider');

    $description.html('');
    if (this.dealerSlider) {
      this.dealerSlider.destroy();
      $imagesWrapper.html('');
    }

    if (!id) return;

    const dealer = this.dealers.find(d => d.id === id);
    const { title, description, address, website, media } = dealer;
    const pantoneText = dealer.pantone_text_all;
    const pantoneImg = dealer.pantone_img;

    if (description && description.length) {
      $('.js-dealers-toggle-more').addClass('is-active');
      $description.show();
      description.forEach(text => $description.append(`<p>${text}</p>`));
    } else {
      $description.hide();
      $('.js-dealers-toggle-more').removeClass('is-active');
    }
    $('.js-dealer-title').text(title || '');
    $('.js-dealer-address').text(address || '');
    $('.js-dealer-website').text(website || '');

    $('.js-dealers-pantone').remove();
    if (pantoneImg && pantoneText) {
      $('.js-dealer-website').after(
        `<div class="dealer__pantone js-dealers-pantone">
            <img src="${pantoneImg}" class="dealer__pantone-icon" alt="${pantoneText}"/>
            <p class="dealer__pantone-text">${pantoneText}</p>
        </div>`
      );
    }

    if (media) {
      media.forEach(src => {
        // check if array of medias has not only images
        if (!/(jpg|gif|png|JPG|GIF|PNG|JPEG|jpeg)$/.test(src)) {
          $imagesWrapper.append(
            `<div class="swiper-slide">
              <div class="dealer-video">
                <div class="dealer-video__video-wrap js-dealer-video" data-src="${src}"></div>
              </div>
            </div>`
          );
        } else {
          $imagesWrapper.append(
            `<div class="swiper-slide">
              <img src="${src}" alt="Шлифарб, дилер - ${title}"/>
            </div>`
          )
        }
      });

      const slidesLength = media.length;
      const loop = slidesLength > 2;

      this.dealerSlider = new Swiper($slider, {
        slidesPerView: 'auto',
        loop,
        loopedSlides: slidesLength,
        on: {
          init() {
            Map.loadVideo();
          }
        },
        pagination: {
          el: $('.js-dealer-slider-wrapper').find('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          599: {
            autoHeight: true,
            spaceBetween: 8,
            centeredSlides: true,
          }
        },
      });
    }
  }

  onResize() {
    if (!this.ps) return
    this.ps.update();
  }

  disableLoader() {
    this.elem.find('.js-lazy-map').hide();
  }

  static loadVideo() {
    const $mediaWrapper = $('.js-dealer-images-wrapper');
    const videos = $mediaWrapper.find('.js-dealer-video');

    videos.each((index, el) => {
      const src = $(el).attr('data-src')
      const newIframe = document.createElement('iframe');
      newIframe.src = `https://www.youtube.com/embed/${src}`;
      newIframe.setAttribute('frameborder', '0');
      newIframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      newIframe.setAttribute('allowfullscreen', '1');
      el.appendChild(newIframe);
    });
  }

  static getUrl(jsonPath) {
    return `${window.location.protocol}//${window.location.host}/${jsonPath}.json`;
  }
}

// eslint-disable-next-line func-names
$.fn.maps = function () {
  return this.each((i, el) => new Map($(el)));
};

$('.js-dealers').maps();
